var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-register dashbord-menu shield-zone"},[_c('div',{staticClass:"wrap-nav"},[_c('nav-logo'),_vm._t("options")],2),_c('div',{staticClass:"nav-actions"},[_vm._t("actions")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }